import { selectors } from 'data'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { history } from 'services/api/positions'

import { actions } from './slice'

const fetch = function* () {
  yield put(actions.reset())
  yield put(actions.loading())
  const { error, response } = yield call(history)
  if (error) {
    yield put(actions.error())
    return
  }

  yield put(actions.setData(response))
}

const fetchNext = function* () {
  const nextPath = yield select(selectors.historical.positions.getNext)
  const { error, response } = yield call(history, nextPath)
  if (error) {
    yield put(actions.error())
    return
  }

  yield put(actions.setData(response))
}

export default function* historicalPositionsMain() {
  yield takeEvery(actions.fetch.type, fetch)
  yield takeEvery(actions.fetchNext.type, fetchNext)
}
